import { MdAdd, MdOutlineSearch } from "react-icons/md";

export interface SearchBarProps {
  showAddButton?: boolean;
  onSearchValueChanged?: (query: string) => void;
  context?: string;
  onAddRecord?: () => void;
  onClick?: () => void;
}

function SearchBar(props: SearchBarProps) {
  return (
    <div className="search-bar">
      <div className="input-group">
        <div className="input-group mb-3">
          <input
            type="search"
            onBlur={(e) => {
              props.onSearchValueChanged?.(e.target.value);
            }}
            className="form-control"
            placeholder={
              props.context && props.context?.length >= 1
                ? `Search for ${props.context}`
                : "Search for records"
            }
            aria-label="control name"
            aria-describedby=""
          />

          <button
            title={`Search for ${props.context}`}
            className="btn btn-outline-secondary"
            type="button"
            id="gridview_btn_search"
            onClick={props.onClick}
          >
            <MdOutlineSearch size={20} />
          </button>
          {props.showAddButton && props.showAddButton === true && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              id="gridview_btn_add"
              onClick={props.onAddRecord}
            >
              <MdAdd size={20} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
